export const IsomerLogoNoText = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      viewBox="0 0 28 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_981_49390"
        maskUnits="userSpaceOnUse"
        x="14"
        y="10"
        width="14"
        height="23"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.3887 10.9336H27.4671V32.5007H14.3887V10.9336Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_981_49390)">
        <path
          d="M26.0358 26.1913C26.0358 26.1913 23.74 27.8138 20.9279 29.5021C18.1158 31.1904 15.8194 32.3259 15.8194 32.3259C15.1419 32.7325 14.593 32.4076 14.593 31.601C14.593 31.601 14.3887 28.742 14.3887 25.6385C14.3887 22.5343 14.593 19.4308 14.593 19.4308C14.593 18.6235 15.1419 17.6395 15.8194 17.2329C15.8194 17.2329 18.018 15.6695 20.9279 13.9227C23.8372 12.1746 26.0358 11.0983 26.0358 11.0983C26.7132 10.6916 27.1956 11.0777 27.2622 11.8225C27.3287 12.5686 27.4671 13.829 27.4671 17.785C27.4671 21.741 27.2622 23.9934 27.2622 23.9934C27.2622 24.8 26.7132 25.784 26.0358 26.1906"
          fill="#2B5FCE"
        />
      </g>
      <path
        d="M25.8557 20.8302L24.0263 19.2637C23.7794 19.0519 23.4612 19.1205 23.3199 19.4156L22.2095 21.7251L22.2108 21.7291L20.12 19.938C19.8731 19.7269 19.5548 19.7955 19.4136 20.0907L16.0327 27.1267C15.8908 27.4218 16.001 27.5247 16.277 27.3553L22.8459 23.3327L25.8023 21.5227C26.0782 21.3533 26.1026 21.0413 25.8557 20.8302"
        fill="white"
      />
      <path
        d="M22.4771 18.2833C22.4771 18.5752 22.2787 18.9313 22.0335 19.0788C21.7883 19.2257 21.5898 19.1088 21.5898 18.8162C21.5898 18.5243 21.7883 18.1682 22.0335 18.0207C22.2787 17.8732 22.4771 17.9907 22.4771 18.2833"
        fill="#B99BF9"
      />
      <mask
        id="mask1_981_49390"
        maskUnits="userSpaceOnUse"
        x="0"
        y="10"
        width="14"
        height="23"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 10.9531H13.0811V32.4983H0V10.9531Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_981_49390)">
        <path
          d="M0.207783 23.9907C0.207783 23.9907 0.00282925 21.7384 0.00282925 17.7824C-0.0244536 14.1327 0.153217 12.5102 0.207783 11.8205C0.262349 11.1315 0.724826 10.7189 1.43418 11.0963C1.43418 11.0963 3.63277 12.1727 6.54205 13.9194C9.452 15.6662 11.6499 17.2296 11.6499 17.2296C12.3273 17.6362 12.877 18.6202 12.877 19.4275C12.877 19.4275 13.0813 22.531 13.0813 25.6352C13.0813 28.7387 12.877 31.5977 12.877 31.5977C12.877 32.4043 12.3273 32.7292 11.6499 32.3219C11.6499 32.3219 9.35418 31.1871 6.54205 29.4981C4.80332 28.4513 3.09977 27.3473 1.43418 26.188C0.756767 25.7814 0.207783 24.7974 0.207783 23.9914"
          fill="#2B5FCE"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.05432 14.1488L5.5198 16.2307H5.52047C5.67508 16.328 5.80037 16.5436 5.80037 16.7126V26.0736C5.80037 26.2419 5.67508 26.2998 5.5198 26.2025L2.05432 24.1199C1.8997 24.0233 1.77441 23.8076 1.77441 23.6387V14.2776C1.77441 14.1094 1.8997 14.0515 2.05432 14.1488ZM6.93399 17.2128L10.6627 19.5538V19.5544C10.8173 19.6511 10.9426 19.866 10.9426 20.0343V23.8307C10.9426 23.9989 10.8173 24.0568 10.6627 23.9595L6.93399 21.6179C6.77937 21.5213 6.65408 21.3063 6.65408 21.138V17.3417C6.65408 17.1734 6.77937 17.1155 6.93399 17.2128Z"
        fill="white"
      />
      <path
        d="M10.672 29.4631L7.07204 27.1317C6.92274 27.0347 6.80176 26.8199 6.80176 26.6523V22.8709C6.80176 22.7033 6.92274 22.6456 7.07204 22.7419L10.672 25.074C10.8219 25.1709 10.9422 25.3857 10.9422 25.5534V29.3347C10.9422 29.5024 10.8219 29.56 10.672 29.4631"
        fill="#B99BF9"
      />
      <mask
        id="mask2_981_49390"
        maskUnits="userSpaceOnUse"
        x="1"
        y="0"
        width="26"
        height="16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.36426 0.964844H26.2581V15.6963H1.36426V0.964844Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_981_49390)">
        <path
          d="M25.7597 9.08779C25.7597 9.08779 23.5866 10.6285 20.6639 12.3609C18.8561 13.4297 17.0138 14.4375 15.14 15.3827C14.4361 15.8001 13.291 15.8014 12.5825 15.3847C12.5825 15.3847 9.75238 13.9733 7.02749 12.3722C4.30259 10.7712 1.89788 9.10788 1.89788 9.10788C1.18937 8.69121 1.18606 8.01597 1.88994 7.59796C1.88994 7.59796 3.9619 6.11751 6.98581 4.32489C8.79198 3.25312 10.6344 2.24522 12.5097 1.30303C13.2136 0.885688 14.1391 0.820709 15.0679 1.30035C15.996 1.78066 17.1498 2.27302 20.6222 4.3135C24.0953 6.35398 25.12 7.13105 25.7518 7.57786C26.3842 8.02535 26.4643 8.66978 25.7597 9.08779"
          fill="#2B5FCE"
        />
      </g>
      <path
        d="M9.16249 7.19475C8.7168 6.94306 8.79255 6.694 9.33156 6.64327L14.9273 6.10628C15.4657 6.05489 15.7862 6.42913 15.6381 6.93713L14.9314 9.37959C14.7846 9.88825 14.2997 10.0984 13.854 9.8474L9.16249 7.19475Z"
        fill="white"
      />
      <path
        d="M23.068 8.25195L13.3673 13.8087L12.7168 13.4389L22.4175 7.88281L23.068 8.25195Z"
        fill="#B99BF9"
      />
      <path
        d="M15.665 11.9077C16.0708 12.1386 16.0727 12.5135 15.6695 12.7451C15.267 12.9772 14.6112 12.9778 14.206 12.7463C13.8002 12.5155 13.7983 12.1405 14.2015 11.9083C14.6041 11.6768 15.2598 11.6762 15.665 11.9077Z"
        fill="white"
      />
    </svg>
  )
}
